<template>
  <div id="playerget">
    <mt-header :title="this.$store.getters.WordsConfig.PlayerGet.head">
      <router-link to slot="left">
        <mt-button icon="back"
                   @click.native="$router.back(-1)">{{wordsfrom.back}}</mt-button>
      </router-link>
    </mt-header>
    <div class="playerget-content">
      <div style="padding: 10px 20px; background-color: white">
        <h3 style="font-size:2rem">{{ this.$store.getters.UserInfo.userName}}</h3>
        <span>{{ wordsfrom.subs }}</span>
      </div>
      <div v-for="(item,index) in linkaddressfrom">
        <div style="height:10px;background-color:#8080804a"></div>

        <div style="padding: 10px 20px; background-color: white;">
          <span>{{wordsfrom.mylink}}</span>
          <hr />
          <div class="input-link">{{item.weblink + wordsfrom.link + userinfo.pcode }}&p={{baset64_P_Param(item.channelid)}}</div>
          <div style="text-align:center;margin-top:10px;">
            <mt-button type="primary"
                       style="width:140px;font-size:1.4rem"
                       v-clipboard:copy="item.weblink + wordsfrom.link + userinfo.pcode + '&p=' + baset64_P_Param(item.channelid)"
                       v-clipboard:success="onCopy">{{ wordsfrom.copylink }}</mt-button>
          </div>
        </div>
        <div style="height:10px;background-color:#8080804a"></div>
        <div style="padding: 10px 20px; background-color: white;">

          <span>{{ wordsfrom.myQRcode }}</span>

          <hr />
          <div style="text-align:center;margin-top:10px">
            <!--<div id="qrcode" ref="qrcode" style="display:none"></div>-->
            <div ref="box" style="width: 20rem;position: absolute;left: -1000px;line-height: 0;">
              <img :src="require('../../assets/img/'+ item.imgsrc +'tgimg.jpg')" style="width:100%" alt @load="loadImage0" crossOrigin="anonymous" />
              <!--<img :src="'data:image/png;base64,'+item.image" style="width:100%" alt @load="loadImage0" />-->
              <!--width: 9rem;position: absolute;bottom: 3.65rem;right: 1.35rem; -->
              <div style="width: 7.65rem;position: absolute;bottom: 3rem;right: 1.2rem;">
                <!--<div class="qrcode" ref="qrCodeUrl"></div>-->
                <img :src="imgUrl[index]" alt @click="showPic" style="width: 100%" @load="loadImage0" />
              </div>
            </div>
            <img v-if="canvasImg.length" :src="canvasImg[index]" style="    width: 100%;max-width:750px;">
            <!--<img :src="imgUrl1[index]" style="width:20rem;" />-->

            <div style="width: 20rem;position: relative;margin: 5px auto;"></div>
            <div style="text-align:center;margin-top:10px;">
              <mt-button style="width:200px;font-size:1.4rem"
                         disabled>{{ wordsfrom.saveQRcode }}</mt-button>
            </div>
          </div>
        </div>
      </div>




    </div>
    <div class="qrcode" ref="qrCodeUrl" style="display:none"></div>


  </div>

</template>

<script>
  import QRCode from "qrcodejs2";
  import html2canvas from "html2canvas";
  import md5 from 'js-md5';
  export default {
    data() {
      return {
        imgUrl: [],
        imgUrl1: [],
        nums: 0,
        linkaddressfrom: [],
        loadPics: 0,
        wordsfrom: [],
        userinfo: [],
        canvasImg: []
      };
    },
    methods: {
      databind() {
        this.wordsfrom = this.$store.getters.WordsConfig.PlayerGet;
        this.userinfo = this.$store.getters.UserInfo;
        console.log(this.userinfo);
        this.linkaddressfrom = this.$store.getters.UserChannelInfo;
        console.log(this.linkaddressfrom);
      },
      baset64_P_Param(cname) {
        return encodeURIComponent(btoa(JSON.stringify({
          id: this.$store.getters.UserInfo.pcode,
          cname: cname,
          device: md5("" + this.$store.getters.UserInfo.pcode+""),
          ltype: 1
        })));
      },
      onCopy(e) {
        this.Toast({
          position: "bottom",
          message: this.$store.getters.WordsConfig.Index.copySuccess
        });
      },
      showPic() {
        let that = this;
        html2canvas(this.$refs.box).then(function (canvas) {
            that.imgUrl1 = canvas.toDataURL("image/png");
        });
      },
      loadImage0() {
        this.loadPics += 1;
      },
      loadImage1() {
        this.loadPics += 1;
      },
      loadnums() {
        this.nums += 1;
        return nums;
      },

      creatQrCode() {

        for (let i = 0; i < this.linkaddressfrom.length; i++) {
          console.log(this.userinfo)
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: this.linkaddressfrom[i].weblink +
              this.wordsfrom.link +
              this.userinfo.pcode +
              '&p=' + this.baset64_P_Param(this.linkaddressfrom[i].weblink),
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        }

      },
      async picUrl() {
        let refs = this.$refs.box;
     
        let url = [];
        const createImg = async (refs) => {
          const canvas = await html2canvas(refs, {
            useCORS: true 
          })
        
          let res = await canvas.toDataURL('image/jpg')
       
          if (!res) return false;
          return res
        };
        for (let i = 0; i < refs.length; i++) {
          url.push(await createImg(this.$refs.box[i]))
        }
        return url
      },


    },


    computed: {

    },
    mounted() {
      this.databind();
      this.creatQrCode();
     
        let myCanvas = document.getElementsByTagName("canvas");
        for (let j = 0; j < myCanvas.length; j++) {
          this.imgUrl[j] = myCanvas[j].toDataURL();
      }
      this.$nextTick(() => {
        setTimeout(async () => {
          this.canvasImg = await this.picUrl()
        }, 100)
      })
    }
  };


</script>

<style lang="scss" scoped>
  #playerget {
    height: 100%;
    overflow: scroll;
  }

  .playerget-content {
    overflow: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 40px;
  }

  .input-link {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    padding: 8px;
    border: solid 1px grey;
    border-radius: 8px;
    word-break: break-all;
    font-size: 1.4rem;
  }

  span {
    font-size: 1.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/PlayerGet.vue